<template>
    <span>{{this.number}}</span>
</template>

<script>
import NumberUtil from '../util/NumberUtil';

export default {
    name : 'percentage',
    props : {
        value : Number,
        decimals : {
            type : Number,
            default : 2,
        },
        or : {
            type : String,
            default : 'Unknown',
        },
    },
    computed : {
        number () {
            if(this.value === null){
                return this.or;
            }
            return NumberUtil.withCommas(this.value, this.decimals) + '%';
        }
    }
}
</script>
